import { decode } from 'safe-base64';

import { removeParams } from './utilities/utils';

class Geolocator {
  constructor() {

    try {
      const params = new URLSearchParams(window.location.search);
      const geo = params.get('geo');
      if (geo) {
        removeParams(['geo']);
        this.data = JSON.parse(decode(geo));
        this._store();
        this._announce();
        return;
      }
    } catch(err) {
      console.warn(`couldn't get geo from url param`, err);
    }

    this.data = this._retrieve();

    if (!this.data) {
      this.fetch();
      return;
    }

    this._announce();
  }

  _store() {
    window.localStorage.setItem('IPAPIInfo', JSON.stringify(this.data));
  }

  _retrieve() {
    try {
      return JSON.parse(window.localStorage.getItem('IPAPIInfo'));
    } catch(err) {
      console.warn('error retrieving stored location info', err);
      window.localStorage.removeItem('IPAPIInfo');
    }

    return null;
  }

  async fetch() {  

    // TO DO: Switch to a window variable controlled with settings.region_code
    const keys = ['234e7953f201b9490be967c0a5a658f70b251da4', '3196f482b5033d6a4ee7630e5adbeebc78fb0dc9'];
    let key = keys[Math.floor(Math.random() * keys.length)];

    const IPAPIResult = await fetch(`https://ipapi.co/json/?key=${ key }`);
    const geolocationInfo = await IPAPIResult.json();

    this.data = geolocationInfo;
    this._store();
    this._announce();

    return geolocationInfo;

  }

  _announce() {
    document.dispatchEvent(new CustomEvent('geolocator:announce', { detail: this.data }));
  }

  get() {
    return this.data;
  }
}

export default Geolocator;